import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import TeachersRoom from './TeachersRoom';
import { treehouseViewModel } from './treehouse.view.modal';
import { useAuth } from '../../auth/Auth';
import { useHistory } from 'react-router-dom';
import { HOME_FEED } from '../../../constants/routes.constants';

const SchoolTeacher = () => {
  const { tid } = useParams();
  const { dependent } = useAuth();
  const history = useHistory();
  const [treehouse, setTreehouse] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const getTreehouseDetails = () => {
    if (dependent && Number(dependent?.profile?.group?.id) === Number(tid)) {
      treehouseViewModel
        .getTribeDetails(tid)
        .then((res) => {
          setTreehouse(res);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      history.push(HOME_FEED);
    }
  };

  useEffect(() => {
    getTreehouseDetails();
  }, []);

  return isLoading ? <Spinner /> : <TeachersRoom treehouse={treehouse} />;
};

export default SchoolTeacher;